import React from 'react';
import logo from '../assets/images/logo-2 (1).png';
import { Image } from 'react-bootstrap';

function menuHeader() {
  return (
    <div style={{ height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {/* <Image src={logo} style={{ width: '50px', height: '50px' }} /> */}
    <p style={{ color: 'white', fontSize: '20px', margin: 0 }}>QMII-ESM</p>
  </div>  
  );
};

export default menuHeader;